import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const SendEmail  = props => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    //console.log(form.current)
    emailjs.sendForm('service_un1ip8h', 'template_eto8zpo', form.current, '3F3oBcRsR1NUegvRR')
      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Message</label>
      <textarea name="message" />
      <input type="submit" value="Send" />
    </form>
  );
};

export default SendEmail;